import styled from "styled-components";
import { Swiper } from "swiper/react";

export const CarouselImage = styled("img")({
  width: "100%",
  height: "100%",
  maxHeight: "100%",
  objectFit: "cover",
});

export const Carousel = styled(Swiper)({
  width: "100%",
  height: "100%",

  "& .ant-skeleton": {
    width: "100%",
    height: "100%",

    "& .ant-skeleton-image": {
      width: "100%",
      height: "100%",
    },
  },
});
